import axios from '../../axios';
import { toast } from 'react-toastify';
import {
   ADD_ITEM_GROUP_ID,
   DELETE_ITEM_GROUP_ID,
   GET_ITEM_GROUP_ID,
   UPDATE_ITEM_GROUP_ID,
   GET_ONE_ITEM_GROUP_ID,
} from '../types';

export const getItemGroup = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/item-group/all', { params });
      if (res.data.code === 1) {
         dispatch({
            type: 'GET_ITEM_GROUP_ID',
            payload: res.data,
         });
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // console.error('Failed to get itemgroup. Please try again. :', err);
   }
};

export const addItemGroup = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/item-group/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_ITEM_GROUP_ID, payload: res.data.data });
         setTimeout(() => {
            toast.success('item-group added successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data)
         if (err.response && err.response.data && err.response.data.code === 1) {
            return;
         }
      const errorMessage = err.response?.data?.errors?.[0]?.message;
      toast.error(errorMessage || 'An error occurred. Please try again.');
      // if (err.response.data.errors[0].message) {
      //    toast.error(err.response.data.errors[0].message);
      // }
      // toast.error('Failed to add item-group. Please try again. :', err);
   }
};

export const updateItemGroup = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/item-group/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_ITEM_GROUP_ID, payload: res.data.data });

         setTimeout(() => {
            toast.success('item-group updated successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

// Delete ItemGroup
export const deleteItemGroup = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/item-group/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_ITEM_GROUP_ID, payload: { id } });
         toast.success('item-group deleted successfully!');
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete item-group. Please try again.');
   }
};

export const getSingleGroupItem = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/item-group/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_ITEM_GROUP_ID, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
